import * as React from "react";
import { animated } from "@react-spring/web";
import { gradient } from "@clockwise/web-commons/src/styles/color.styles";
import { makeStyles } from "@material-ui/styles";
import { fontFamilyHelvetica } from "@clockwise/web-commons/src/styles/type.styles";
import { ConfettiCanvas, SpringScaleGrow } from "@components/spring-animations";

const useStyles = makeStyles({
  gradientCard: {
    height: "200px",
    width: "279px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: gradient,
    borderRadius: " 0 0 8px 8px",
    marginLeft: "-12px",
    marginBottom: "-12px",
    position: "relative",
    paddingTop: 10,
  },
  growText: {
    fontFamily: fontFamilyHelvetica,
    fontSize: `1.2rem`,
    color: "white",
    fontWeight: "bold",
  },
  confettiCanvas: {
    position: "absolute",
    height: "200px",
    width: "279px",
  },
});

export const ChecklistConfetti = () => {
  const classes = useStyles();

  return (
    <animated.div className={classes.gradientCard}>
      <ConfettiCanvas className={classes.confettiCanvas} />
      <SpringScaleGrow className={classes.growText}>"Great work 🙌"</SpringScaleGrow>
    </animated.div>
  );
};
